export const columnModel = [
  {
    groupId: ' ',
    children: [{ field: 'nazwa' }, { field: 'comments' }, { field: 'weight' }, { field: 'type' }, { field: 't' }],
  },
  {
    groupId: 'Etap1',
    children: [
      { field: 'stage1_1' },
      { field: 'stage1_2' },
      { field: 'stage1_3' },
      { field: 'stage1_4' },
      { field: 'stage1_5' },
      { field: 'stage1_6' },
      { field: 'stage1_7' },
      { field: 'stage1_8' },
      { field: 'stage1_9' },
      { field: 'stage1_10' },
      { field: 'stage1_11' },
      { field: 'stage1_12' },
      { field: 'stage1_13' },
      { field: 'stage1_14' },
      { field: 'stage1_15' },
      { field: 'stage1_16' },
      { field: 'stage1_17' },
      { field: 'stage1_18' },
      { field: 'stage1_19' },
      { field: 'stage1_20' },
    ],
  },
  {
    groupId: 'Etap2',
    children: [
      { field: 'stage2_1' },
      { field: 'stage2_2' },
      { field: 'stage2_3' },
      { field: 'stage2_4' },
      { field: 'stage2_5' },
      { field: 'stage2_6' },
      { field: 'stage2_7' },
      { field: 'stage2_8' },
      { field: 'stage2_9' },
      { field: 'stage2_10' },
      { field: 'stage2_11' },
      { field: 'stage2_12' },
      { field: 'stage2_13' },
      { field: 'stage2_14' },
      { field: 'stage2_15' },
    ],
  },
];


export const tableStyles = {
  root: {
    '& .MuiDataGrid-root': {
      scrollSnapType: 'x mandatory',
    },
    '& .MuiDataGrid-row': {
      scrollSnapAlign: 'start',
    },
    '& .MuiDataGrid-row:nth-of-type(odd)': {
      backgroundColor: '#f5f5f5', // Alternatywne kolory wierszy
    },
    '& .MuiDataGrid-cell--stickyLeft': {
      position: 'sticky !important', // Upewnij się, że styl jest ważniejszy niż domyślny
      left: 0,
      backgroundColor: 'white',
      zIndex: 100, // Zwiększenie z-index, aby kolumna była na wierzchu
      borderRight: '1px solid #ddd',
    },
    '& .MuiDataGrid-columnHeader--stickyLeft': {
      position: 'sticky !important', // Upewnij się, że styl jest ważniejszy niż domyślny
      left: 0,
      backgroundColor: 'white',
      zIndex: 101, // Zwiększenie z-index, aby nagłówek był na wierzchu
      borderRight: '1px solid #ddd',
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'auto', // Umożliwia przewijanie poziome
    },
    '& .MuiDataGrid-columnHeaders': {
      position: 'sticky',
      top: 0,
      zIndex: 99, // Zwiększenie z-index, aby nagłówki były na wierzchu
      backgroundColor: 'white', // Tło, aby nagłówki nie były przezroczyste
    },
  },
};

